// extracted by mini-css-extract-plugin
module.exports = {"root":"NameBlock_root__2XTq7","nameWrapper":"NameBlock_nameWrapper__30PI_","name":"NameBlock_name__1edDL","type":"NameBlock_type__2s4au"};